import { Container, CssBaseline } from '@mui/material';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { Theme } from '@mui/material/styles/createTheme';
import useAdobeTarget from '@shared/hooks/useAdobeTarget';

import carmaxTheme from '../../theme/carmaxTheme';
import Banner from './components/Banner';
import Footer from './components/Footer';
import Header from './components/Header';
import SubHeader from './components/SubHeader';
import WebVitals from './components/WebVitals';
import styles from './LayoutContainer.module.scss';

interface Props {
    includeFooter?: boolean;
    hideSubHeader?: boolean;
    hideBanner?: boolean;
    minimizedHeader?: JSX.Element;
    layoutType?: LayoutBodyType | LayoutBodyType.Default;
    children: JSX.Element | Array<JSX.Element>;
    header?: JSX.Element;
    /**
     * Adds SearchBar as Header component.
     * Requires AuthProvider as parent component.
     */
    includeSearchBar?: boolean;
    theme?: Theme;
}

export enum LayoutBodyType {
    Default,
    FullWidth,
}

export default function LayoutContainer({
    minimizedHeader,
    includeFooter,
    hideSubHeader,
    hideBanner,
    layoutType,
    children,
    header,
    includeSearchBar = false,
    theme = carmaxTheme,
}: Props) {
    useAdobeTarget();

    const headerComponent = header ? header : <Header includeSearchBar={includeSearchBar} />;

    return (
        <ThemeProvider theme={theme}>
            <StyledEngineProvider injectFirst>
                <CssBaseline />
                {hideBanner ? <></> : <Banner />}
                {minimizedHeader ? minimizedHeader : headerComponent}
                {hideSubHeader ? <></> : <SubHeader />}
                <Container
                    className={styles['main-container']}
                    disableGutters={layoutType === LayoutBodyType.FullWidth}
                    maxWidth={layoutType === LayoutBodyType.FullWidth ? false : 'lg'}>
                    <main>{children}</main>
                    <WebVitals />
                </Container>
                {includeFooter ? <Footer /> : <></>}
                <div id="kmx-portal"></div>
            </StyledEngineProvider>
        </ThemeProvider>
    );
}
